import { toast } from 'react-toastify';
import { MarkerConstants } from '../_constants';
import { MarkersService } from '../_services';

export const MarkerActions = {
  getMarkersByMap,
  getMarkersByChronicle,
  createMarker,
  updateMarker,
  deleteMarker,
  loadFromChronicle,
  getMarkerTypes,
};
function loadFromChronicle(payload) {
  return {
    type: MarkerConstants.POPULATE_MARKERS,
    payload,
  };
}
function getMarkersByMap(mapID) {
  return (dispatch) => {
    dispatch(request(mapID));

    return MarkersService.getMarkersByMap(mapID).then(
      (markers) => {
        dispatch(success(markers));
      },
      (error) => {
        const message = error.toString();
        console.log(`[Chronos] Error - Get Map Markers (Map): `, error);
        toast.error('Unable to retrieve Map Markers.');
        dispatch(failure(message));
      }
    );
  };

  function request(mapID) {
    return {
      type: MarkerConstants.FETCH_MAP_MARKERS_REQUEST,
      props: { map: mapID },
    };
  }

  function success(result) {
    return {
      type: MarkerConstants.FETCH_MAP_MARKERS_SUCCESS,
      payload: result,
    };
  }

  function failure(error) {
    return {
      type: MarkerConstants.FETCH_MAP_MARKERS_FAILURE,
      error,
    };
  }
}

function getMarkersByChronicle(chronicleID) {
  return (dispatch) => {
    dispatch(request(chronicleID));

    return MarkersService.getMarkersByChronicle(chronicleID).then(
      (markers) => {
        dispatch(success(markers));
      },
      (error) => {
        const message = error.toString();
        console.log(`[Chronos] Error - Get Map Markers (Chronicle): `, error);
        toast.error('Unable to retrieve Map Markers.');
        dispatch(failure(message));
      }
    );
  };

  function request(chronicleID) {
    return {
      type: MarkerConstants.FETCH_CHRONICLE_MARKERS_REQUEST,
      props: { chronicle: chronicleID },
    };
  }

  function success(result) {
    return {
      type: MarkerConstants.FETCH_CHRONICLE_MARKERS_SUCCESS,
      payload: result,
    };
  }

  function failure(error) {
    return {
      type: MarkerConstants.FETCH_CHRONICLE_MARKERS_FAILURE,
      error,
    };
  }
}

function createMarker(markerData) {
  return (dispatch) => {
    dispatch(request(markerData));

    return MarkersService.createMarker(markerData).then(
      (marker) => {
        toast.success(`Map Marker "${marker.title}" created successfully!`);
        dispatch(success(marker));
      },
      (error) => {
        const message = error.toString();
        console.log(`[Chronos] Error - Create Map Marker: `, error);
        toast.error(`Unable to create Map Marker "${markerData.title}"`);
        dispatch(failure(message));
      }
    );
  };

  function request(markerData) {
    return {
      type: MarkerConstants.CREATE_MARKER_REQUEST,
      props: { marker: markerData },
    };
  }

  function success(marker) {
    return {
      type: MarkerConstants.CREATE_MARKER_SUCCESS,
      payload: marker,
    };
  }

  function failure(error) {
    return {
      type: MarkerConstants.CREATE_MARKER_FAILURE,
      error,
    };
  }
}

function updateMarker(markerData, markerID) {
  return (dispatch) => {
    dispatch(request(markerData));

    if (!markerID) {
      markerID = markerData._id;
    }

    return MarkersService.updateMarker(markerID, markerData).then(
      (marker) => {
        toast.success(`Map Marker "${marker.title}" updated successfully!`);
        dispatch(success(marker));
      },
      (error) => {
        const message = error.toString();
        console.log(`[Chronos] Error - Update Map Marker: `, error);
        dispatch(failure(message));
      }
    );
  };

  function request(markerData) {
    return {
      type: MarkerConstants.UPDATE_MARKER_REQUEST,
      props: { marker: markerData },
    };
  }

  function success(marker) {
    return {
      type: MarkerConstants.UPDATE_MARKER_SUCCESS,
      payload: marker,
    };
  }

  function failure(error) {
    return {
      type: MarkerConstants.UPDATE_MARKER_FAILURE,
      error,
    };
  }
}

function deleteMarker(markerID) {
  return (dispatch) => {
    dispatch(request(markerID));

    return MarkersService.deleteMarker(markerID).then(
      () => {
        toast.success(`Map Marker successfully deleted!`);
        dispatch(success(markerID));
      },
      (error) => {
        const message = error.toString();
        console.log(`[Chronos] Error - Delete Map Marker: `, error);
        toast.error(`Unable to delete Map Marker.`);
        dispatch(failure(message));
      }
    );
  };

  function request(markerID) {
    return {
      type: MarkerConstants.DELETE_MARKER_REQUEST,
      props: { marker: markerID },
    };
  }

  function success(markerID) {
    return {
      type: MarkerConstants.DELETE_MARKER_SUCCESS,
      payload: markerID,
    };
  }

  function failure(error) {
    return {
      type: MarkerConstants.DELETE_MARKER_FAILURE,
      error,
    };
  }
}

function getMarkerTypes() {
  return (dispatch) => {
    dispatch(request());

    return MarkersService.fetchMarkerTypes().then(
      (markerTypes) => {
        dispatch(success(markerTypes));
        return markerTypes;
      },
      (error) => {
        const message = error.toString();
        console.log('[CHRONOS] Error: Fetching Marker Types', message);
        dispatch(failure(message));
      }
    );
  };

  function request(params) {
    return {
      type: MarkerConstants.FETCH_MARKER_TYPES_REQUEST,
      params,
    };
  }

  function success(payload) {
    return {
      type: MarkerConstants.FETCH_MARKER_TYPES_SUCCESS,
      payload,
    };
  }

  function failure(error) {
    return {
      type: MarkerConstants.FETCH_MARKER_TYPES_FAILURE,
      error,
    };
  }
}
